import useBookingModulePermissions from "PFApp/use_booking_module_permissions";
import { useBooking } from "PFCore/hooks/queries";
import { useProfile } from "PFCore/hooks/queries/profile/use_profile";
import useBookingCategories from "PFCore/hooks/use_booking_categories";
import { useCallback } from "react";

import { DetailsPanelData } from "../details_panel.types";
import { useCanOpenDetailsPanelOfType } from "./use_can_open_details_panel_of_type";

interface UsePrerequisiteChecker {
  data?: DetailsPanelData;
}
type UsePrerequisiteCheckerReturn = ({ type }: Partial<Pick<DetailsPanelData, "type">>) => boolean;

export const usePrerequisiteChecker = ({ data }: UsePrerequisiteChecker): UsePrerequisiteCheckerReturn => {
  const { id, type } = data || {};
  const { data: booking } = useBooking(id as number, { enabled: !!id && type === "booking" });
  const { data: profile } = useProfile(id || -1, { enabled: !!id && type === "profile" });
  const { getCategory } = useBookingCategories();
  const { isEnabled: isBMEnabled } = useBookingModulePermissions();
  const canOpenDetailsPanelOfType = useCanOpenDetailsPanelOfType();

  return useCallback(
    ({ type }) => {
      if (!isBMEnabled || !type || !canOpenDetailsPanelOfType(type)) {
        return false;
      }

      switch (type) {
        case "booking":
          return !!booking && !!getCategory(booking);
        case "profile":
          return !!profile;
        default:
          return true;
      }
    },
    [booking, getCategory, profile]
  );
};
